import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { ratingList } from '@/common/demand';
import { assignmentDemand as _assignmentDemand } from '@/api/demand/demand';

var validateWorkHours = function validateWorkHours(rule, value, callback) {
  // 正的，小数部分以5结尾的浮点数  或  正整数
  var reg = /^\d*(\.(5|0))?$/;

  if (!reg.test(value) || Number(value) <= 0) {
    callback(new Error('工时消耗（h）只允许输入0.5的整数倍'));
  } else {
    callback();
  }
};

var validateWorkDays = function validateWorkDays(rule, value, callback) {
  if (/[^\d]+/.test(value) || Number(value) <= 0) {
    callback(new Error('只能输入正整数'));
  } else {
    callback();
  }
};

export default {
  props: {
    dialogConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hideDialog: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      submitButton: {
        loading: false,
        disabled: false
      },
      formConfig: {
        inline: false,
        labelPosition: 'right',
        labelWidth: '130px'
      }
    };
  },


  computed: {
    innerFormValue: function innerFormValue() {
      return this.formValue;
    },
    formItemList: function formItemList() {
      return [{
        label: '需求名称',
        prop: 'name',
        type: 'input',
        subtype: 'textarea',
        params: {
          disabled: true
        }
      }, {
        label: '需求说明',
        prop: 'instruction',
        type: 'input',
        subtype: 'textarea',
        params: {
          disabled: true
        }
      }, {
        label: '期望完成日期',
        prop: 'expect_time',
        type: 'input',
        params: {
          disabled: true
        }
      }, {
        label: '需求评级',
        prop: 'difficulty',
        type: 'select',
        rules: [{
          required: true,
          message: '请选择需求评级',
          trigger: 'change'
        }],
        params: {
          options: ratingList,
          clearable: true
        }
      }, {
        // 已提交和待配置美术资源状态补课更改是否需要策划师选项
        visible: this.formValue.type === 1 && this.formValue.status === 'submited',
        label: '需要策划跟进否',
        prop: 'skip_plan',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '是否需要策划跟进',
          trigger: 'change'
        }],
        params: {
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        visible: this.formValue.type === 1 && this.formValue.status === 'submited' && this.formValue.skip_plan === 2,
        label: '指定策划师',
        prop: 'planner_id',
        type: 'business',
        subtype: 'planner-selector',
        rules: [{
          required: true,
          message: '指定策划师',
          trigger: 'change'
        }],
        params: {
          options: [],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '指派设计师',
        prop: 'designer_id',
        type: 'business',
        subtype: 'designer-selector',
        rules: [{
          required: true,
          message: '请指派设计',
          trigger: 'change'
        }],
        params: {
          options: [],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        label: '工时消耗（h）',
        prop: 'work_hours',
        type: 'input-number',
        visible: this.formValue.type === 2,
        rules: [{ validator: validateWorkHours, trigger: 'change' }, {
          required: true,
          message: '请填写工时消耗，0.5的倍数',
          trigger: 'change'
        }],
        params: {
          clearable: true,
          class: 'input-work_hours',
          step: 0.5,
          controlsPosition: 'right',
          placeholder: '请填写工时消耗，0.5的倍数',
          min: 0.5
        }
      }, {
        label: '工时消耗（day）',
        prop: 'work_days',
        type: 'input-number',
        visible: this.formValue.type === 1,
        rules: [{ validator: validateWorkDays, trigger: 'change' }, {
          required: true,
          message: '请填写工时消耗',
          trigger: 'change'
        }],
        params: {
          class: 'input-work_days',
          clearable: true,
          controlsPosition: 'right',
          placeholder: '请填写工时消耗'
        }
      }, {
        label: '计划完成日期',
        prop: 'estimated_time',
        type: 'date-picker',
        subtype: 'date',
        rules: [{
          required: true,
          message: '请填写计划完成日期',
          trigger: 'change'
        }],
        params: {
          clearable: true,
          pickerOptions: {},
          placeholder: '选择日期'
        }
      }, {
        visible: this.formValue.type === 1 && this.formValue.status === 'submited',
        label: '是否需要研发',
        prop: 'no_dev',
        type: 'radio-group',
        rules: [{
          required: true,
          message: '请选择是否需要研发',
          trigger: 'change'
        }],
        params: {
          options: [{
            label: '需要',
            value: 2
          }, {
            label: '不需要',
            value: 1
          }],
          placeholder: '请选择',
          filterable: true,
          clearable: true
        }
      }, {
        visible: this.formValue.type === 1 && this.formValue.status === 'submited' && this.formValue.no_dev === 2,
        label: '研发人员',
        type: 'business',
        subtype: 'developer-selector',
        prop: 'developer_id',
        rules: [{
          required: true,
          message: '请分配研发人员',
          trigger: 'change'
        }],
        params: {
          filterable: true
        }
      }];
    }
  },

  mounted: function mounted() {},


  watch: {
    'dialogConfig.visible': function dialogConfigVisible(val) {
      var _this = this;

      this.$nextTick(function () {
        _this.resetFields();
      });
    }
  },

  methods: {
    handleChange: function handleChange(val, prop) {},
    handleValidate: function handleValidate(prop) {},
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) _this2.assignmentDemand();
      });
    },
    assignmentDemand: function assignmentDemand() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  designer_id: Number(_this3.innerFormValue.designer_id),
                  estimated_time: _this3.innerFormValue.estimated_time,
                  difficulty: _this3.innerFormValue.difficulty
                };


                if (_this3.innerFormValue.type === 1) {
                  data = _extends({}, data, {
                    work_days: parseFloat(_this3.innerFormValue.work_days)
                    // 只有提交状态下才需要提交策划师和研发人员相关数据
                  });if (_this3.innerFormValue.status === 'submited') {
                    // 策划师
                    data.skip_plan = _this3.innerFormValue.skip_plan;
                    if (data.skip_plan === 2) {
                      data.planner_id = Number(_this3.innerFormValue.planner_id);
                    }
                    // 研发人员
                    data.no_dev = _this3.innerFormValue.no_dev;
                    if (data.no_dev === 2) {
                      data.developer_id = Number(_this3.innerFormValue.developer_id);
                    }
                  }
                }
                if (_this3.innerFormValue.type === 2) {
                  data.work_hours = parseFloat(_this3.innerFormValue.work_hours);
                }

                _this3.submitButton.loading = true;
                _context.prev = 4;
                _context.next = 7;
                return _assignmentDemand(_this3.innerFormValue.id, data);

              case 7:
                _this3.submitButton.loading = false;
                _this3.$message({ message: '更新成功！', type: 'success' });
                _this3.hideDialog();
                _this3.$emit('success');
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](4);

                // this.$message({
                //   message: err.message || '更新失败！',
                //   type: 'error'
                // })
                _this3.submitButton.loading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[4, 13]]);
      }))();
    },
    onCancel: function onCancel() {
      this.hideDialog();
    },
    resetFields: function resetFields() {
      // this.$refs.form.resetFields()
      this.$refs.form && this.$refs.form.clearValidate();
    }
  }
};